import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const propertyTypeApi = createApi({
    reducerPath: 'propertyTypeApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/property_types`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getPropertyTypes: build.query({
            query() {
                return {
                    url: '/getAll',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Property Types']
        }),
        createPropertyType: build.mutation({
            query: (data) => ({
                url: '/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Property Types']
        }),
        deletePropertyType: build.mutation({
            query(id) {
                return {
                    url: `/delete/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['Property Types']
        }),
        updatePropertyType: build.mutation({
            query({ id, data }) {
                return {
                    url: `/update/${id}`,
                    method: 'PUT',
                    body: data
                }
            },
            invalidatesTags: ['Property Types']
        }),
    }),
});

export const {
    useLazyGetPropertyTypesQuery,
    useGetPropertyTypesQuery,
    useCreatePropertyTypeMutation,
    useDeletePropertyTypeMutation,
    useUpdatePropertyTypeMutation
}
    = propertyTypeApi;